module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/AysyWI/tc-custom/scover.jpg?1692044807109?1713839778646",
      "alt": "This image is the cover for the book Worst. Power. Ever., Vic and Matt"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Worst. Power. Ever., Vic and Matt\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("A Vic and Matt Story")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("Vic Braunson shares a very sexy secret with his lover, Matt diLorenzo -- something in Matt's semen gives Vic superhuman powers. While the powers fade over time, most of them come in handy. But every now and then, he draws a doozy ..."), _c('br'), _c('br'), _vm._v("This short, erotic romp was originally written as part of the series, "), _c('i', [_vm._v("The Positions of Love")]), _vm._v(" . In the end, it was a bit depressing, really, because Vic doesn't really save the day or anything, so I scrapped it for a different power. But I thought I'd rework it into a stand-alone story for Vic and Matt fans.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      J.M. Snyder\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0